import { createStyles } from '@material-ui/core';

export default () => createStyles({
  cell: {
    textAlign: 'center',
  },
  rank: {
    whiteSpace: 'nowrap',
  },
});
